<script setup>
import { RouterLink } from "vue-router";
import AppLogo from "./AppLogo.vue";
import UserMenu from "./UserMenu.vue";

defineProps({
  sticky: { type: Boolean, default: true },
});
</script>

<template>
  <header
    class="z-[1000] flex-shrink-0 border-b border-[var(--color-border)] bg-[var(--color-surface)]/95 backdrop-blur-sm"
    :class="sticky ? 'sticky top-0' : ''"
  >
    <div
      data-testid="authenticated-header-inner"
      class="app-chrome-container flex min-h-[65px] items-center justify-between gap-4 py-3"
    >
      <div
        data-testid="authenticated-header-brand"
        class="flex-1 min-w-0 flex items-center gap-3"
      >
        <slot name="before-brand" />
        <RouterLink
          to="/dashboard"
          aria-label="PermitPilott home"
          class="flex-shrink-0 flex items-center gap-2.5 hover:opacity-80 transition-opacity"
        >
          <AppLogo :size="36" aria-hidden="true" />
          <div class="type-chrome-brand hidden text-white sm:block">
            PERMIT<span class="text-[var(--brand-accent)]">PILOTT</span>
          </div>
        </RouterLink>
        <slot name="after-brand" />
      </div>

      <div
        data-testid="authenticated-header-actions"
        class="ml-auto flex-shrink-0 flex items-center justify-end gap-2"
      >
        <slot />
        <UserMenu />
      </div>
    </div>
  </header>
</template>
